import { childElements } from './dom.js';
import { Rational } from './rational.js';
import { absoluteNoteEvents, scoreTempoEvents, summarizePart } from './timing.js';

function vlq(value:number):number[]{if(value<0)throw new Error('negative delta');const a=[value&127];value>>>=7;while(value){a.push((value&127)|128);value>>>=7;}return a.reverse();}
function ticks(v:Rational,ppq:number):number{const n=v.n*BigInt(ppq);if(n%v.d!==0n)throw new Error(`PPQ=${ppq} cannot exactly represent ${v}`);return Number(n/v.d);}
const u16=(n:number)=>[(n>>>8)&255,n&255],u32=(n:number)=>[(n>>>24)&255,(n>>>16)&255,(n>>>8)&255,n&255];
function tempoBytes(bpm:Rational):number[]{
 const value=60_000_000/(Number(bpm.n)/Number(bpm.d));
 const us=Math.round(value);
 if(!Number.isFinite(us)||us<=0||us>0xffffff)throw new Error(`Tempo ${bpm} BPM cannot be represented as an SMF Set Tempo event.`);
 return[0xff,0x51,3,(us>>>16)&255,(us>>>8)&255,us&255];
}

export function referenceMidi(doc:Document,partId?:string,ppq=960):Uint8Array{
 const parts=childElements(doc.documentElement,'part');if(!parts.length)throw new Error('No parts.');
 const part=parts.find(p=>p.getAttribute('id')===partId)??parts[0]!;
 const raw:Array<[number,number,number[]]>=[];
 for(const e of scoreTempoEvents(doc))raw.push([ticks(e.onset,ppq),-2,tempoBytes(e.bpm)]);
 for(const e of absoluteNoteEvents(part)){
  raw.push([ticks(e.onset,ppq),1,[0x90,e.midi&127,e.velocity&127]],[ticks(e.onset.add(e.duration),ppq),0,[0x80,e.midi&127,0]]);
 }
 raw.sort((a,b)=>a[0]-b[0]||a[1]-b[1]);
 const track:number[]=[];let last=0;
 for(const [tick,,msg]of raw){track.push(...vlq(tick-last),...msg);last=tick;}
 const total=ticks(summarizePart(part),ppq);track.push(...vlq(Math.max(0,total-last)),0xff,0x2f,0);
 return new Uint8Array([0x4d,0x54,0x68,0x64,...u32(6),...u16(0),...u16(1),...u16(ppq),0x4d,0x54,0x72,0x6b,...u32(track.length),...track]);
}
